module.exports = __webpack_public_path__ + "img/头像@2x.b6a98065.png";